import { render } from "./LekoTechAI.vue?vue&type=template&id=7e63af8d&scoped=true"
import script from "./LekoTechAI.vue?vue&type=script&lang=js"
export * from "./LekoTechAI.vue?vue&type=script&lang=js"

import "./LekoTechAI.vue?vue&type=style&index=0&id=7e63af8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e63af8d"]])

export default __exports__